import React, { FC } from "react";
import type { EndUserAppsSimplifyPayingProps } from "@/types";
import { Tags } from "../tags";
import { TextCols } from "../text-cols";

export const EndUserAppsSimplifyPaying: FC<EndUserAppsSimplifyPayingProps> = ({
  content,
  tags,
}) => {
  return (
    <section className="endUserAppsSimplifyPaying">
      <div className="wrapper">
        <TextCols content={content} size="md" maxTitleWidth={742} />
      </div>
      <div className="wrapper">
        <div className="endUserAppsSimplifyPaying--subtitle">
          Disbursers can choose the form factor to deliver recipients’ funds, or
          they can allow recipients to decide:
        </div>
      </div>
      <Tags tags={tags} className="endUserAppsSimplifyPaying--tags" />
    </section>
  );
};
